





import {Component, Prop, Ref, Vue} from 'vue-property-decorator';

@Component
export default class JdhBoundedSelector extends Vue {

    @Ref() mainEl!: HTMLElement

    @Prop({default: false, type: Boolean}) expand!: boolean

    // allow values beyond [0~1]
    @Prop({default: false, type: Boolean}) unbind!: boolean

    active = false
    mainWidth = 0
    mainHeight = 0

    x = 0
    y = 0
    inBounds = false

    mounted() {
        this.mainEl.addEventListener('pointerdown', this.handleStart)
        this.mainEl.addEventListener('pointerup', this.handleStop)

        // TODO: handle resizes -- listen to global, or use resize observer?
    }

    handleStart(e: PointerEvent) {
        this.mainEl.addEventListener('pointermove', this.handleMove)
        this.mainEl.setPointerCapture(e.pointerId)
        this.mainWidth = this.mainEl.getBoundingClientRect().width
        this.mainHeight = this.mainEl.getBoundingClientRect().height
        this.active = true

        document.body.style.webkitUserSelect = 'none'
        this.handleMove(e)
    }

    handleMove(e: PointerEvent) {
        if (this.unbind) {
            this.x = e.offsetX / this.mainWidth
            this.y = e.offsetY / this.mainHeight
        } else {
            this.x = Math.max(Math.min(e.offsetX / this.mainWidth, 1), 0)
            this.y = Math.max(Math.min(e.offsetY / this.mainHeight, 1), 0)
        }
        this.$emit('move', {x: this.x, y: this.y})
    }

    handleStop(e: PointerEvent) {
        this.mainEl.removeEventListener('pointermove', this.handleMove)
        this.mainEl.releasePointerCapture(e.pointerId)
        this.active = false

        document.body.style.webkitUserSelect = 'auto'
    }

    beforeDestroy() {
        this.mainEl.removeEventListener('pointerdown', this.handleStart)
        this.mainEl.removeEventListener('pointerup', this.handleStop)
    }

    get mainClasses() {
        return {
            'jdsc-bounded-selector--expand': this.expand,
        }
    }

}
